import { activePage, replaceActivePage } from "./pages";
import type { EngineDocument, Point } from "../scene/model";
import type { Box } from "./geometry";
import { assertNativeDocument } from "./document";
export type CropEdge = "left" | "right" | "top" | "bottom";
export function cropBounds(box: Box): Box {
  if (
    ![box.x, box.y, box.width, box.height].every(Number.isFinite) ||
    box.width < 1 ||
    box.height < 1 ||
    box.width > 16384 ||
    box.height > 16384 ||
    Math.abs(box.x) > 1e6 ||
    Math.abs(box.y) > 1e6
  )
    throw new Error("Введите размер кадрирования от 1 до 16384 px.");
  return {
    x: Math.round(box.x),
    y: Math.round(box.y),
    width: Math.max(1, Math.round(box.width)),
    height: Math.max(1, Math.round(box.height)),
  };
}
export function resizeCrop(
  box: Box,
  edge: CropEdge,
  point: Point,
  centered = false,
): Box {
  const b = { ...box };
  if (edge === "left" || edge === "right") {
    const fixed = edge === "left" ? box.x + box.width : box.x;
    const center = box.x + box.width / 2;
    const w = Math.max(1, edge === "left" ? fixed - point.x : point.x - fixed);
    b.width = Math.min(
      16384,
      centered
        ? Math.max(
            1,
            2 * (edge === "left" ? center - point.x : point.x - center),
          )
        : w,
    );
    b.x = centered
      ? center - b.width / 2
      : edge === "left"
        ? fixed - b.width
        : fixed;
  } else {
    const fixed = edge === "top" ? box.y + box.height : box.y;
    const center = box.y + box.height / 2;
    const h = Math.max(1, edge === "top" ? fixed - point.y : point.y - fixed);
    b.height = Math.min(
      16384,
      centered
        ? Math.max(
            1,
            2 * (edge === "top" ? center - point.y : point.y - center),
          )
        : h,
    );
    b.y = centered
      ? center - b.height / 2
      : edge === "top"
        ? fixed - b.height
        : fixed;
  }
  return b;
}
export function cropExpansion(
  box: Box,
  size: { width: number; height: number },
) {
  return (
    box.x <= 0 &&
    box.y <= 0 &&
    box.x + box.width >= size.width &&
    box.y + box.height >= size.height &&
    (box.width > size.width || box.height > size.height)
  );
}
export function cropDocument(document: EngineDocument, box: Box) {
  const b = cropBounds(box),
    page = activePage(document);
  const result = replaceActivePage(document, {
    ...page,
    size: { width: b.width, height: b.height },
    nodes: page.nodes.map((n) => ({
      ...n,
      transform: {
        ...n.transform,
        x: n.transform.x! - b.x,
        y: n.transform.y! - b.y,
      },
    })),
  });
  assertNativeDocument(result);
  return result;
}
